import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles.scss';
import * as hooks from './hooks';
import ContentCard from '../ContentCard';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { PATH_NAMES } from '../../constants/pathNames.js';
import { CONTENT_TYPES } from '../../constants/contentTypes';

function ContentRelated({
  translationTexts,
  content,
  onClickContentSelected,
  contentNoImageProps,
  contentCardProps = {},
  imageMode = 'POSTER',
  textMode = 'none',
  networks,
  isLoading,
  countItem = 30
}) {

  let relatedList = []

  if (isLoading) {
    relatedList.push(...new Array(countItem))
  } else {
    relatedList = content.result;
  }

  //#region //// HOOKS ////
  hooks.useDidMount();
  //#endregion

  // const handleContentRelated = (contentId) => {
  //   setContentRelatedIdSelected(contentId);
  // }
  // relatedList = relatedList.filter(cont => cont.contentType == "MOVIE")

  return (
    <React.Fragment>
      <Container fluid className={`contentRelatedWrapped contentType_${textMode.toLocaleLowerCase()}`}>
        { relatedList?.length ? 
          <div className="contentRelatedHead">
            <h2 className="contentRelatedTitle">
              {translationTexts.similar_titles || translationTexts.related }
            </h2>
          </div>
        : ''}
        
        <div className="contentRelatedList">
          {
            relatedList?.map((related, index) => {
              return (
                <FadeIn key={index} delay={index*40}>
                  <div className="contentRelatedPoster">
                    <Nav.Link
                      href={
                        `/${related?.live && related?.contentType === CONTENT_TYPES.SPORT ? PATH_NAMES.CONTENT_LIVE : PATH_NAMES.CONTENT_OVERVIEW}/${related?.id}`
                      }
                      onClick={(ev) => onClickContentSelected(ev, related?.id)}
                    >

                      <ContentCard
                        {...contentCardProps}
                        content={related}
                        contentNoImageProps={contentNoImageProps}
                        imageMode={imageMode}
                        textMode={textMode}
                        isLoading={isLoading}
                        networks={networks}
                        translationTexts={translationTexts}
                      />
                      {/* <Image id="poster" src={imageValid || NoImage} rounded className={imageValid ? '':  'noImageResize'} /> */}
                    </Nav.Link>
                  </div>
                </FadeIn>
              )
            })
          }

        </div>
      </Container>
    </React.Fragment>
  );
}

ContentRelated.propTypes = {
  content: PropTypes.shape({
    result: PropTypes.array.isRequired,
  }),
  onClickContentSelected: PropTypes.func,
  isLoading: PropTypes.bool,
  countItem: PropTypes.number,
  networks: PropTypes.array
};

export default WithErrorBoundary(React.memo(ContentRelated));
